import React from 'react'
import { Box, Container, Divider, Grid, Typography } from '@mui/material'
import { useTranslation } from 'next-i18next'
import ArticleCard from './ArticleCard'

function ArticleSearchResult({ data }) {
  const { t } = useTranslation(['common'])
  const articles = data?.reduce((allArticles, item) => [...allArticles, ...item.articles], []) ?? []
  return (
    <Box py={13}>
      <Container maxWidth="xl">
        <Grid
          container
          spacing={15}
        >
          <Grid
            item
            xs={12}
          >
            <Grid
              container
              spacing={5}
              alignItems="stretch"
            >
              <Grid
                item
                xs={12}
              >
                <Typography
                  variant="h4"
                  display="block"
                  textTransform="capitalize"
                  textAlign="center"
                >
                  {t('common:search_result')}
                </Typography>
              </Grid>
              <Grid
                item
                xs={12}
              >
                <Grid
                  container
                  spacing={2}
                >
                  {!articles.length && (
                    <Grid
                      item
                      xs={12}
                    >
                      <Typography
                        display="block"
                        gutterBottom
                        variant="caption"
                        color="neutral.dark"
                        textAlign="center"
                      >
                        {t('common:there_is_no_search_result')}
                      </Typography>
                    </Grid>
                  )}
                  {articles?.map((article, index) => (
                    <React.Fragment key={article.id}>
                      <Grid
                        item
                        xs={12}
                      >
                        <ArticleCard
                          article={article}
                          showCategory
                        />
                      </Grid>
                      {articles.length !== index + 1 && (
                        <Grid
                          item
                          xs={12}
                        >
                          <Divider />
                        </Grid>
                      )}
                    </React.Fragment>
                  ))}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </Box>
  )
}

export default ArticleSearchResult
